import { TableCell, TableRow } from '@mui/material';
import React from 'react';

const DetailsModelTableRow = ({
  title,
  description,
  values,
  bgColor = '',
  boldValues = false,
  hideDetails,
}) => {
  const displayedValues = hideDetails ? [values[values.length - 1]] : values;
  return (
    <TableRow sx={{ backgroundColor: bgColor }}>
      <TableCell>
        <b>{title}</b>

        {description && (
          <>
            <br />
            <b>{description}</b>
          </>
        )}
      </TableCell>
      {displayedValues.map((value, i) => (
        <TableCell key={i}>{boldValues ? <b>{value}</b> : <>{value}</>}</TableCell>
      ))}
    </TableRow>
  );
};

export default DetailsModelTableRow;
